import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  imports: [RouterModule, CommonModule, LoginComponent],
})
export class AuthComponent {
  router = inject(Router);
  logoimage = 'assets/loginScreen/logo.png';
  logoimage1 = 'assets/loginScreen/logo1.png';
  logoimage2 = 'assets/loginScreen/logo3.jpeg';
  logoimage3 = 'assets/loginScreen/logo4.jpeg';

  navigateSingup(): void {
    this.router.navigate(['/auth/signup']);
  }
}
